import { Component, computed, input, Signal } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TableColumn } from '../../models/table-column';
import { TableColumnType } from '../../enums/table-column-type';
import { Nillable, valueOrDefault } from '@web/utils';
import { TableHeaderCurrentPageRowSelectionCheckboxComponent } from '../table-header-current-page-row-selection-checkbox/table-header-current-page-row-selection-checkbox.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'th[app-table-header-cell]',
  imports: [TableModule, TableHeaderCurrentPageRowSelectionCheckboxComponent],
  templateUrl: './table-header-cell.component.html',
  styleUrls: ['./table-header-cell.component.scss'],
})
export class TableHeaderCellComponent<Item, Filter> {
  public readonly column = input.required<TableColumn<Item, Filter>>();

  protected readonly columnType = this.columnTypeSignal();
  protected readonly columnLabel = this.columnLabelSignal();
  protected readonly sortKey = this.sortKeySignal();
  protected readonly isSortableColumn = this.isSortableColumnSignal();
  protected readonly TableColumnType = TableColumnType;

  private columnTypeSignal(): Signal<TableColumnType> {
    return computed(() => this.column().type);
  }

  private columnLabelSignal(): Signal<string> {
    return computed(() => valueOrDefault(this.column().label, ''));
  }

  private sortKeySignal(): Signal<Nillable<string>> {
    return computed(() => this.column().sortKey);
  }

  private isSortableColumnSignal(): Signal<boolean> {
    return computed(() => this.column().sortable);
  }
}
